/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Privacy_TitleInputs */

const es_tyc_privacy_title = /** @type {(inputs: Tyc_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Privacidad y Proteccion de Datos`)
};

const en_tyc_privacy_title = /** @type {(inputs: Tyc_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Privacy and Data Protection`)
};

/**
* | output |
* | --- |
* | "8. Privacy and Data Protection" |
*
* @param {Tyc_Privacy_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_privacy_title = /** @type {((inputs?: Tyc_Privacy_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Privacy_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_privacy_title(inputs)
	return en_tyc_privacy_title(inputs)
});
export { tyc_privacy_title as "tyc.privacy.title" }